import { StrictMode, useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route, useNavigate, useParams } from 'react-router-dom'
import PublicHeader from '@/components/public/PublicHeader'
import PublicQuoteActionsPage from '@/pages/Public/PublicQuoteActionsPage'
import ExpiredPage from '@/pages/Public/ExpiredPage'
import PublicQuoteViewPage from '@/pages/Public/PublicQuoteViewPage'
import SaleConfirmationPage from '@/pages/Public/SaleConfirmationPage'
import TransportOrderSigningPage from '@/pages/Public/TransportOrderSigningPage'
import ReviewRedirectPage from '@/pages/Public/ReviewRedirectPage'
import VideoPage from '@/pages/Public/VideoPage'
import PublicInfoPage from '@/pages/Public/PublicInfoPage'
import ThanksPage from '@/pages/Public/ThanksPage'
import { showToast, setToastDefaults } from '@/config/toast.config'
import LoadingSpinner from '@/components/common/LoadingSpinner/LoadingSpinner'
import '@/index.css'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const API_BASE = import.meta.env.VITE_API_BASE_URL

export function CustomersApp() {
  // Disable copy button for all toasts in the customers app
  setToastDefaults({ disableCopy: true })
  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      // Block PWA install prompt on public customers pages
      e.preventDefault();
    };
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  }, []);

  const TokenEntryRouter = () => {
    const { token } = useParams()
    const navigate = useNavigate()
    const [checking, setChecking] = useState(true)
    useEffect(() => {
      (async () => {
        try {
          if (!API_BASE || !token) return
          const res = await fetch(`${API_BASE}/public/quotes/${encodeURIComponent(token)}/status`)
          if (!res.ok) return
          const json = await res.json().catch(() => ({}))
          const status = String(json?.status || '').toLowerCase()
          if (status === 'submitted') {
            navigate('/thanks', { replace: true })
            return
          }
          if (status === 'expired') {
            navigate('/expired', { replace: true })
            return
          }
          if (status === 'invalid') {
            navigate('/info', { replace: true })
            return
          }
          setChecking(false)
        } catch (error) {
          showToast.error(error)
          setChecking(false)
        }
      })()
    }, [token, navigate])
    if (checking) {
      return (
        <div className="min-h-screen flex items-center justify-center">
          <LoadingSpinner size="lg" />
        </div>
      )
    }
    return <PublicQuoteActionsPage />
  }

  return (
    <BrowserRouter>
      <PublicHeader />
      <Routes>
        <Route path="/:token" element={<TokenEntryRouter />} />
        <Route path="/comanda/:token" element={<SaleConfirmationPage />} />
        <Route path="/semnare/:token" element={<TransportOrderSigningPage />} />
        <Route path="/r/:token" element={<ReviewRedirectPage />} />
        <Route path="/v/:code" element={<VideoPage />} />
        <Route path="/view/:token" element={<PublicQuoteViewPage />} />
        <Route path="/thanks" element={<ThanksPage />} />
        <Route path="/expired" element={<ExpiredPage />} />
        <Route path="/info" element={<PublicInfoPage />} />
        <Route path="/" element={<PublicInfoPage />} />
        <Route path="*" element={<PublicInfoPage />} />
      </Routes>
      <ToastContainer 
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        limit={3}
        style={{ zIndex: 100000 }}
      />
    </BrowserRouter>
  )
}


const root = createRoot(document.getElementById('root'))
root.render(
  <StrictMode>
    <CustomersApp />
  </StrictMode>
)


